export enum ENV_NAME {
  DEV = 'DEVELOPMENT',
  AZURE_DEV = 'AZURE_DEVELOPMENT',
  STAGING = 'STAGING',
  PROD = 'PRODUCTION',
  LOCALHOST = 'LOCALHOST',
}

export function getEnvironment(): ENV_NAME {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT;
  switch (env) {
    case 'localhost':
      return ENV_NAME.LOCALHOST;
    case 'azure_dev':
      return ENV_NAME.AZURE_DEV;
    case 'development':
      return ENV_NAME.DEV;
    case 'staging':
      return ENV_NAME.STAGING;
    case 'production':
      return ENV_NAME.PROD;
    default:
      return ENV_NAME.DEV;
  }
}
